import { render, staticRenderFns } from "./figment-profile.vue?vue&type=template&id=e999409e&"
import script from "./figment-profile.vue?vue&type=script&lang=js&"
export * from "./figment-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports